const ChatSendIcon = ({ className = "w-4 h-4", mirrored = false }) => (
  <svg
    className={`${className}${mirrored ? " rotate-180" : ""}`}
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      d={
        mirrored
          ? "M2 21l21-9L2 3v7l15 2-15 2v7z"
          : "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
      }
    />
  </svg>
);

export default ChatSendIcon;
